import { JavaScriptResource } from '@lib/iab/iab-vast-model';

interface IJavaScriptResource {
    apiFramework: string;
    _value: string;
}

const createJavaScriptResource = (
    $javascriptResource: IJavaScriptResource
): JavaScriptResource => {
    const res = new JavaScriptResource();
    res.apiFramework = $javascriptResource.apiFramework;
    res.uri = $javascriptResource._value;
    return res;
};

export default createJavaScriptResource;
